import type { Ingredient as IngredientType } from '@cooklang/cooklang-ts'
import Ingredient from './Ingredient.tsx'

type ModifiedIngredientType = Pick<
	IngredientType,
	'name' | 'quantity' | 'units'
>

export default function IngredientList({
	ingredients,
}: {
	ingredients: ModifiedIngredientType[]
}) {
	return (
		// <fieldset className="lg:border-stone-400 lg:bg-background lg:p-4">
		<fieldset>
			<div className="space-y-2 text-base sm:pl-4 md:pl-0 lg:text-lg">
				{ingredients.map((ingredient, i) => {
					return <Ingredient key={i} {...ingredient} />
				})}
			</div>
		</fieldset>
	)
}
